export default function Footer() {
  return (
    <div className="footer dark-bg">
      <h3>
        © {new Date().getFullYear()} Jonathan Carrasco-Noriega
      </h3>
    </div>
  );
}